var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      staticClass: "sl-modal",
      attrs: {
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": "",
        id: "userWizardModal",
        maximized: _vm.maximized,
        value: _vm.open,
        "content-css": { width: "1270px", maxWidth: "100%" }
      },
      on: {
        hide: function($event) {
          _vm.closeAndClearModal()
        }
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c(
                "q-toolbar-title",
                [
                  _c("q-icon", { attrs: { name: "fa fa-magic" } }),
                  _vm._v("New User Wizard\n      ")
                ],
                1
              ),
              _c("q-icon", {
                attrs: { name: "clear" },
                nativeOn: {
                  click: function($event) {
                    _vm.closeAndClearModal()
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-stepper",
            {
              ref: "userStepper",
              attrs: {
                "alternative-labels": "",
                "no-header-navigation": _vm.hideBack
              },
              model: {
                value: _vm.currentStep,
                callback: function($$v) {
                  _vm.currentStep = $$v
                },
                expression: "currentStep"
              }
            },
            [
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.nextStep()
                    }
                  }
                },
                [
                  _c(
                    "q-step",
                    { attrs: { name: "roles", title: "Roles", order: "0" } },
                    [
                      _c("user-wizard-roles", { attrs: { validation: _vm.$v } })
                    ],
                    1
                  ),
                  _c(
                    "q-step",
                    {
                      class: { active: _vm.currentStep == "details" },
                      attrs: {
                        default: "",
                        name: "userForm",
                        title: "Details",
                        order: "1"
                      }
                    },
                    [
                      _c("user-details", { attrs: { validation: _vm.$v } }),
                      _c("user-notes")
                    ],
                    1
                  ),
                  _c(
                    "q-step",
                    {
                      attrs: {
                        name: "addresses",
                        title: "Addresses",
                        order: "2"
                      }
                    },
                    [_c("user-addresses", { attrs: { validation: _vm.$v } })],
                    1
                  ),
                  _vm.managerForm.ACTIVE_IND
                    ? _c(
                        "q-step",
                        {
                          attrs: {
                            name: "managerForm",
                            title: "Manager",
                            order: "5"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "q-pa-xl" },
                            [
                              _c(
                                "h5",
                                [
                                  _c("q-icon", {
                                    attrs: {
                                      name: "fa fa-users",
                                      color: "primary"
                                    }
                                  }),
                                  _vm._v(" Manager Details")
                                ],
                                1
                              ),
                              _c("q-select", {
                                staticClass: "q-mt-lg",
                                attrs: {
                                  multiple: "",
                                  chips: "",
                                  "float-label": "Manager Courses",
                                  value: _vm.managerCourses,
                                  options: _vm.courseOptions
                                },
                                on: {
                                  input: function(val) {
                                    return _vm.updateManagerCourses(val)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.recruiterForm.ACTIVE_IND
                    ? _c(
                        "q-step",
                        {
                          attrs: {
                            name: "recruiterForm",
                            title: "Recruiter",
                            order: "3"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "relative" },
                            [
                              _c("user-recruiter-form-details", {
                                attrs: { validation: _vm.validation }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.affiliateForm.ACTIVE_IND
                    ? _c(
                        "q-step",
                        {
                          attrs: {
                            name: "affiliateForm",
                            title: "Affiliate",
                            order: "4"
                          }
                        },
                        [
                          _c("user-affiliate-form-details", {
                            attrs: { validation: _vm.validation }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.instructorForm.ACTIVE_IND
                    ? _c(
                        "q-step",
                        {
                          attrs: {
                            name: "instructorForm",
                            title: "Instructor",
                            order: "5"
                          }
                        },
                        [
                          _c("user-instructor-form-details", {
                            attrs: { validation: _vm.validation }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "q-step",
                    {
                      attrs: {
                        name: "changePasswordForm",
                        title: "Security",
                        order: "6"
                      }
                    },
                    [
                      _c("user-security", {
                        attrs: { validation: _vm.validation }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-step",
                    {
                      attrs: {
                        name: "documents",
                        title: "Documents",
                        order: "7"
                      }
                    },
                    [_c("user-documents")],
                    1
                  ),
                  _c(
                    "q-step",
                    { attrs: { name: "finish", title: "Finish", order: "8" } },
                    [_c("user-wizard-finish")],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "q-toolbar",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("q-toolbar-title"),
              _vm.currentStep === "documents"
                ? _c("q-btn", {
                    staticStyle: { "margin-right": "10px" },
                    attrs: { color: "green", label: "Upload Documents" },
                    on: {
                      click: function($event) {
                        _vm.openUploadModal()
                      }
                    }
                  })
                : _vm._e(),
              _c(
                "q-stepper-navigation",
                [
                  _c("q-btn", {
                    attrs: {
                      color: "blue",
                      disable: _vm.submitting,
                      loading: _vm.submitting,
                      label: _vm.nextStepLabel
                    },
                    on: {
                      click: function($event) {
                        _vm.nextStep()
                      }
                    }
                  }),
                  _c("q-btn", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.hideBack,
                        expression: "!hideBack"
                      }
                    ],
                    attrs: { color: "secondary", flat: "", label: "Back" },
                    on: {
                      click: function($event) {
                        _vm.$refs.userStepper.previous()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }